import React from 'react';
import { TFunction } from 'i18next';
import styles from './Chat.module.scss';
import { ChatAttachment } from '../../../services/chat';
import { downloadAttachment, MimeType } from '../../../services/utility';
import Icon from '../../ui/Icon/Icon';

const getPlaceholderImageFromMimetype = (mimetype: string) => {
  switch (mimetype) {
    case MimeType.PDF: {
      return '/assets/chat/pdf.png';
    }
    case MimeType.JPEG:
    case MimeType.PNG: {
      return '/assets/chat/image.png';
    }
    default: {
      return '/assets/chat/file.png';
    }
  }
};

export const Attachment = ({
  attachment: { id, mimetype, filename },
  t,
}: {
  attachment: ChatAttachment;
  t: TFunction;
}) => (
  <div
    role="button"
    className={styles.attachmentCard}
    onClick={() => downloadAttachment(id)}
    onKeyDown={e => {
      if (e.key === 'Enter' || e.key === ' ') downloadAttachment(id);
    }}
    tabIndex={0}>
    <img className={styles.attachmentCard_icon} src={getPlaceholderImageFromMimetype(mimetype)} alt="attachment_icon" />
    <div className="flex flex-col mx-16">
      <span className="typo-text-14--medium text-full break-words">{filename}</span>
      <span className="typo-text-12 text-faded">{t('chat.downloadFile')}</span>
    </div>
    <Icon name="download" width={20} height={20} className={styles.attachmentCard_downloadIcon} />
  </div>
);
